import React from "react";
import { Link } from "react-router-dom";
import { Star, ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";
import { trackAddToCart } from "../lib/tracking";
import { toast } from "../hooks/use-toast";

export default function ProductCard({ product }) {
  const { addItem } = useCart();

  const handleAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addItem(product);
    trackAddToCart(product, 1);
    toast({ title: "Adicionado ao carrinho", description: product.name });
  };

  const discount = product.oldPrice
    ? Math.round((1 - product.price / product.oldPrice) * 100)
    : 0;

  return (
    <Link
      to={`/produto/${product.id}`}
      className="group flex flex-col bg-card rounded-lg overflow-hidden border border-transparent hover:border-border hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] transition-all duration-300"
    >
      <div className="relative aspect-square bg-secondary overflow-hidden">
        <img
          src={product.images[0]}
          alt={product.name}
          loading="lazy"
          className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        {product.badge && (
          <span
            className={`absolute top-3 left-3 text-[11px] font-semibold px-2.5 py-1 rounded-full ${
              product.isNew
                ? "bg-foreground text-white"
                : "bg-primary text-primary-foreground"
            }`}
          >
            {product.badge}
          </span>
        )}
        <button
          onClick={handleAdd}
          className="absolute bottom-3 right-3 h-10 w-10 rounded-full bg-white text-foreground shadow-md flex items-center justify-center opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 hover:bg-primary hover:text-primary-foreground transition-all duration-300"
          aria-label="Adicionar ao carrinho"
        >
          <ShoppingBag className="h-4.5 w-4.5 h-4 w-4" />
        </button>
      </div>

      <div className="p-4 flex flex-col flex-1">
        <span className="text-[11px] uppercase tracking-wider text-muted-foreground">
          {product.brand}
        </span>
        <h3 className="text-sm font-medium mt-1 leading-snug line-clamp-2 group-hover:text-primary transition-colors">
          {product.name}
        </h3>
        <div className="flex items-center gap-1 mt-1.5">
          <Star className="h-3.5 w-3.5 fill-primary text-primary" />
          <span className="text-xs font-medium">{product.rating}</span>
          <span className="text-xs text-muted-foreground">({product.reviews})</span>
        </div>

        <div className="mt-auto pt-3 flex items-baseline gap-2">
          <span className="text-base font-semibold text-foreground">
            € {product.price.toFixed(2)}
          </span>
          {product.oldPrice && (
            <>
              <span className="text-xs text-muted-foreground line-through">
                € {product.oldPrice.toFixed(2)}
              </span>
              <span className="text-xs font-semibold text-primary ml-auto">
                -{discount}%
              </span>
            </>
          )}
        </div>
      </div>
    </Link>
  );
}
